import { c as _c } from "react/compiler-runtime";
import { Stack, type StackProps } from '@mui/material';
import { type Dispatch, type SetStateAction, useCallback } from 'react';
import { ListOptions } from './ListOptions';
import type { SingleSelectOption } from './';
type Props = StackProps<'div', {
  id: string;
  isOpen: boolean;
  closeDropdown: () => void;
  activeIndex: number;
  setActiveIndex: Dispatch<SetStateAction<number>>;
  scrollBackToMainBar?: () => void;
  options: SingleSelectOption[];
  optionsId: string;
  selectedOption?: string;
  onChange: (value: string) => void;
}>;
export const ListBox = t0 => {
  const $ = _c(37);
  let activeIndex;
  let closeDropdown;
  let id;
  let isOpen;
  let onChange;
  let options;
  let optionsId;
  let props;
  let scrollBackToMainBar;
  let selectedOption;
  let setActiveIndex;
  if ($[0] !== t0) {
    ({
      id,
      isOpen,
      closeDropdown,
      activeIndex,
      setActiveIndex,
      scrollBackToMainBar,
      options,
      optionsId,
      selectedOption,
      onChange,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = activeIndex;
    $[2] = closeDropdown;
    $[3] = id;
    $[4] = isOpen;
    $[5] = onChange;
    $[6] = options;
    $[7] = optionsId;
    $[8] = props;
    $[9] = scrollBackToMainBar;
    $[10] = selectedOption;
    $[11] = setActiveIndex;
  } else {
    activeIndex = $[1];
    closeDropdown = $[2];
    id = $[3];
    isOpen = $[4];
    onChange = $[5];
    options = $[6];
    optionsId = $[7];
    props = $[8];
    scrollBackToMainBar = $[9];
    selectedOption = $[10];
    setActiveIndex = $[11];
  }
  let t1;
  if ($[12] !== closeDropdown || $[13] !== onChange || $[14] !== scrollBackToMainBar) {
    t1 = value => {
      closeDropdown();
      setTimeout(() => {
        onChange(value);
      }, 100);
      if (scrollBackToMainBar) {
        scrollBackToMainBar();
      }
    };
    $[12] = closeDropdown;
    $[13] = onChange;
    $[14] = scrollBackToMainBar;
    $[15] = t1;
  } else {
    t1 = $[15];
  }
  const handleSelectOption = t1;
  let t2;
  if ($[16] !== options || $[17] !== setActiveIndex) {
    t2 = directionMove => setActiveIndex(index => (index + directionMove + options.length) % options.length);
    $[16] = options;
    $[17] = setActiveIndex;
    $[18] = t2;
  } else {
    t2 = $[18];
  }
  const moveOnList = t2;
  let t3;
  if ($[19] !== closeDropdown || $[20] !== moveOnList || $[21] !== options || $[22] !== setActiveIndex) {
    t3 = e => {
      bb10: switch (e.key) {
        case "ArrowDown":
          {
            e.preventDefault();
            moveOnList(1);
            break bb10;
          }
        case "ArrowUp":
          {
            e.preventDefault();
            moveOnList(-1);
            break bb10;
          }
        case "Home":
          {
            e.preventDefault();
            setActiveIndex(0);
            break bb10;
          }
        case "End":
          {
            e.preventDefault();
            setActiveIndex(options.length - 1);
            break bb10;
          }
        case "Escape":
          {
            e.preventDefault();
            closeDropdown();
            break bb10;
          }
        case "Tab":
          {
            e.preventDefault();
            closeDropdown();
          }
      }
    };
    $[19] = closeDropdown;
    $[20] = moveOnList;
    $[21] = options;
    $[22] = setActiveIndex;
    $[23] = t3;
  } else {
    t3 = $[23];
  }
  const onKeyList = t3;
  let t4;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      maxHeight: "200px",
      overflowY: "auto"
    };
    $[24] = t4;
  } else {
    t4 = $[24];
  }
  let t5;
  if ($[25] !== activeIndex || $[26] !== handleSelectOption || $[27] !== id || $[28] !== isOpen || $[29] !== options || $[30] !== selectedOption) {
    t5 = <ListOptions id={id} isOpen={isOpen} activeIndex={activeIndex} handleSelectOption={handleSelectOption} options={options} selectedOption={selectedOption} />;
    $[25] = activeIndex;
    $[26] = handleSelectOption;
    $[27] = id;
    $[28] = isOpen;
    $[29] = options;
    $[30] = selectedOption;
    $[31] = t5;
  } else {
    t5 = $[31];
  }
  let t6;
  if ($[32] !== onKeyList || $[33] !== optionsId || $[34] !== props || $[35] !== t5) {
    t6 = <Stack role="listbox" id={optionsId} tabIndex={0} sx={t4} onKeyDown={onKeyList} {...props}>{t5}</Stack>;
    $[32] = onKeyList;
    $[33] = optionsId;
    $[34] = props;
    $[35] = t5;
    $[36] = t6;
  } else {
    t6 = $[36];
  }
  return t6;
};